"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestIconImagePath = void 0;
const Quest_1 = require("../classes/Quest");
const QuestState_1 = require("../types/QuestState");
const definables_1 = require("definables");
const getQuestPartyState_1 = require("./getQuestPartyState");
const getQuestIconImagePath = (questID) => {
    const quest = (0, definables_1.getDefinable)(Quest_1.Quest, questID);
    const state = (0, getQuestPartyState_1.getQuestPartyState)(questID);
    if (state === QuestState_1.QuestState.Complete) {
        return "quest-icons/complete";
    }
    if (quest.hasMonster()) {
        return "quest-icons/monsters";
    }
    throw new Error("Quest does not have an icon");
};
exports.getQuestIconImagePath = getQuestIconImagePath;
